import { render } from "./LessonVideo.vue?vue&type=template&id=542548db&scoped=true"
import script from "./LessonVideo.vue?vue&type=script&lang=js"
export * from "./LessonVideo.vue?vue&type=script&lang=js"

import "./LessonVideo.vue?vue&type=style&index=0&id=542548db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542548db"]])

export default __exports__